import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconVariants';
/** Renders an SVG icon. */
const SvgVariants = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M22 21a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm2-14a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3z"
      />
      <path
        fill="currentColor"
        d="M26 11v14a1 1 0 0 1-1 1H11a1 1 0 0 1-1-1v-1a1 1 0 1 0-2 0v1a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V11a3 3 0 0 0-3-3h-1a1 1 0 1 0 0 2h1a1 1 0 0 1 1 1"
      />
      <path
        fill="currentColor"
        d="M14 8a1 1 0 0 1 .923.616l1.088 2.615 2.824.227a1 1 0 0 1 .571 1.757l-2.152 1.842.658 2.757a1.001 1.001 0 0 1-1.494 1.084L14 17.422l-2.418 1.476a1 1 0 0 1-1.494-1.084l.657-2.757-2.151-1.842a1 1 0 0 1 .571-1.757l2.823-.227 1.09-2.615.067-.134A1 1 0 0 1 14 8m-.4 4.563a1 1 0 0 1-.842.614l-1.036.083.789.675c.285.245.409.628.322.993l-.241 1.01.886-.542a1 1 0 0 1 1.043 0l.886.541-.24-1.01a1 1 0 0 1 .322-.992l.788-.675-1.035-.083a1 1 0 0 1-.843-.614l-.399-.96z"
      />
    </svg>
  );
};
SvgVariants.displayName = displayName;
export default SvgVariants;
